import React from "react";
import Hint from "~/assets/js/components/Hint";
import i18n from "~/assets/js/Helpers/i18n";
import PropTypes from "prop-types";

const CategoryItems = ({ tags }) => {
    const tagsObj = {
        vegan: {
            hintText: "categoryItems.vegan",
            icon: "vegan",
        },
        vegetarisch: {
            hintText: "categoryItems.vegetarian",
            icon: "vegetarian",
        },
        glutenfrei: {
            hintText: "categoryItems.glutenFree",
            icon: "gluten-free",
        },
        zuckerfrei: {
            hintText: "categoryItems.sugarFree",
            icon: "sugar-free",
        },
        "weniger-als-30-kalorien": {
            hintText: "categoryItems.lowCarbs",
            icon: "low-carb",
        },
        /* TODO: bring that back when image exists
        klimafreundlich: {
            hintText: "categoryItems.klima",
            icon: "sampling",
        },*/
    };

    return (
        <div className="product_categories">
            {tags.map((tag) => {
                if (tag in tagsObj) {
                    return (
                        <Hint
                            hintText={i18n.t(tagsObj[tag].hintText)}
                            key={tagsObj[tag].hintText}
                        >
                            <CategoryItem
                                icon={tagsObj[tag].icon}
                                key={tagsObj[tag].hintText}
                            />
                        </Hint>
                    );
                }
            })}
        </div>
    );
};

export const CategoryItem = ({ icon }) => {
    const { iconPath } = reactConfig;
    return <img alt={icon} src={`${iconPath}/${icon}.svg`} />;
};

CategoryItems.propTypes = {
    tags: PropTypes.array.isRequired,
};

CategoryItem.propTypes = {
    icon: PropTypes.string.isRequired,
};

export default CategoryItems;
